module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-mailchimp"
  }, [(!_vm.states.submitted) ? _c('div', {
    staticClass: "sky-mailchimp-signup"
  }, [(_vm.merged.text.teaser) ? _c('p', {
    staticClass: "teaser",
    domProps: {
      "textContent": _vm._s(_vm.merged.text.teaser)
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "formElement",
    attrs: {
      "novalidate": ""
    }
  }, [_vm._l((_vm.merged.form), function(input) {
    return (input.type === 'email' || _vm.currentStep === 'submit') ? _c('div', {
      key: input.name,
      ref: ((input.name) + "Parent"),
      refInFor: true,
      staticClass: "form-group"
    }, [((input.type) === 'checkbox') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mailchimp[input.name]),
        expression: "mailchimp[input.name]"
      }, {
        name: "sky-approve",
        rawName: "v-sky-approve",
        value: (input.id || input.name),
        expression: "input.id || input.name"
      }],
      ref: input.name,
      refInFor: true,
      attrs: {
        "name": input.name,
        "placeholder": input.placeholder,
        "required": input.required,
        "disabled": ((_vm.states.unauthorized) && (input.type === 'email')) || ((input.type === 'email') && (_vm.currentStep === 'submit') && _vm.advanced),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.mailchimp[input.name]) ? _vm._i(_vm.mailchimp[input.name], null) > -1 : (_vm.mailchimp[input.name])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.mailchimp[input.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.mailchimp[input.name] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.mailchimp[input.name] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.mailchimp, input.name, $$c)
          }
        }
      }
    }) : ((input.type) === 'radio') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mailchimp[input.name]),
        expression: "mailchimp[input.name]"
      }, {
        name: "sky-approve",
        rawName: "v-sky-approve",
        value: (input.id || input.name),
        expression: "input.id || input.name"
      }],
      ref: input.name,
      refInFor: true,
      attrs: {
        "name": input.name,
        "placeholder": input.placeholder,
        "required": input.required,
        "disabled": ((_vm.states.unauthorized) && (input.type === 'email')) || ((input.type === 'email') && (_vm.currentStep === 'submit') && _vm.advanced),
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(_vm.mailchimp[input.name], null)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.mailchimp, input.name, null)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mailchimp[input.name]),
        expression: "mailchimp[input.name]"
      }, {
        name: "sky-approve",
        rawName: "v-sky-approve",
        value: (input.id || input.name),
        expression: "input.id || input.name"
      }],
      ref: input.name,
      refInFor: true,
      attrs: {
        "name": input.name,
        "placeholder": input.placeholder,
        "required": input.required,
        "disabled": ((_vm.states.unauthorized) && (input.type === 'email')) || ((input.type === 'email') && (_vm.currentStep === 'submit') && _vm.advanced),
        "type": input.type
      },
      domProps: {
        "value": (_vm.mailchimp[input.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.mailchimp, input.name, $event.target.value)
        }
      }
    }), _vm._v(" "), (input.showLabel) ? _c('label', {
      attrs: {
        "for": input.name
      },
      domProps: {
        "textContent": _vm._s(input.label)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "help-block",
      domProps: {
        "textContent": _vm._s(input.helpText)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-danger",
      domProps: {
        "textContent": _vm._s(input.error)
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.mailchimp.groups), function(group, gIndex) {
    return (_vm.advanced && _vm.currentStep === 'submit') ? _c('div', {
      key: group.id,
      staticClass: "form-group checkboxes"
    }, [(group.name) ? _c('label', {
      domProps: {
        "textContent": _vm._s(group.name)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "checkboxes"
    }, _vm._l((group.items), function(checkbox, cIndex) {
      return _c('div', {
        key: cIndex,
        staticClass: "checkbox"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": checkbox.checked
        },
        on: {
          "click": function($event) {
            _vm.toggleCheckbox(group.id, cIndex)
          }
        }
      }), _vm._v(" "), _c('label', {
        domProps: {
          "textContent": _vm._s(checkbox.value)
        }
      })])
    })), _vm._v(" "), _c('span', {
      staticClass: "text-danger",
      domProps: {
        "textContent": _vm._s('Vælg min. et nyhedsbrev.')
      }
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.states.unauthorized) ? _c('div', {
    staticClass: "form-group"
  }, [(!_vm.states.requestedUpdateLink) ? _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.merged.text.status.hasSubscription)), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.buttonObject.updateLink)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.requestUpdateLink($event)
      }
    }
  }), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.states.requestedUpdateLink) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.merged.text.status.updateLinkSent)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.states.unauthorized) ? _c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.buttonObject), function(value, key) {
    return (_vm.currentStep === key) ? _c('button', {
      key: key,
      class: key,
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.buttonHub(key)
        }
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(value)
      }
    }), _vm._v(" "), _c('sky-svg', {
      attrs: {
        "name": "arrow"
      }
    })], 1) : _vm._e()
  })) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['sky-mailchimp-loader', {
      'show': _vm.states.loading
    }]
  }, [_c('div', {
    staticClass: "sky-mailchimp-loader-wrap"
  }, [_c('span', {
    staticClass: "sky-mailchimp-loader-content",
    domProps: {
      "textContent": _vm._s(_vm.loaderText)
    }
  })])]), _vm._v(" "), (_vm.states.submitted) ? _c('div', {
    staticClass: "sky-mailchimp-feedback"
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.feedbackText.header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.feedbackText.description)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-f0eae35c"}!./scripts/sky-mailchimp/sky-mailchimp.html
// module id = 388
// module chunks = 1